import { createAction, props } from '@ngrx/store';

export const setTargetRatesShowRecessions = createAction(
    '[Target Rates Page] Set Show Recessions',
    props<{ showRecessions: boolean }>()
);
